<template>
  <el-dialog :visible.sync="visible" title="检测报告" width="1200px" :close-on-click-modal="true" append-to-body
    custom-class="battery-report-dialog" @opened="loadData" @closed="clearData">
    <template slot="title">
      <span class="dialog-title-text">检测报告</span>
      <!-- <div class="dialog-title-actions">
        <i class="el-icon-download" title="下载" @click="handleDownload"></i>
        <i class="el-icon-close" title="关闭" @click="visible = false"></i>
      </div> -->
    </template>
    <div class="report-toolbar">
      <el-date-picker v-model="reportDateTime" type="datetime" placeholder="选择时间（不选查最近一次）"
        value-format="yyyy-MM-dd HH:mm:ss" size="small" style="width: 220px" clearable
        @change="onReportDateTimeChange" />
      <el-button type="primary" size="small" :loading="loading" @click="loadData">查询</el-button>
    </div>
    <div v-loading="loading" class="report-body">
      <template v-if="report">
        <!-- 一、基本信息 -->
        <section class="report-section">
          <h3 class="section-title">一、基本信息</h3>
          <table class="info-table">
            <tbody>
              <tr>
                <td class="label">车辆VIN</td>
                <td class="value">{{ report.vin || '—' }}</td>
                <td class="label">车辆企业</td>
                <td class="value">{{ report.factoryName || '—' }}</td>
              </tr>
              <tr>
                <td class="label">车辆型号</td>
                <td class="value">{{ report.vehicleModel || '—' }}</td>
                <td class="label">整车型号</td>
                <td class="value">{{ report.vehicleWholeModel || '—' }}</td>
              </tr>
              <tr>
                <td class="label">动力电池类型</td>
                <td class="value">{{ report.batteryName || '—' }}</td>
                <td class="label">动力电池编码</td>
                <td class="value">—</td>
              </tr>
              <tr>
                <td class="label">动力电池额定容量(Ah)</td>
                <td class="value">{{ report.nominalCapacity || '—' }}</td>
                <td class="label">动力电池额定电压(V)</td>
                <td class="value">{{ report.ratedVoltage || '—' }}</td>
              </tr>
              <tr>
                <td class="label">车辆总里程(KM)</td>
                <td class="value">{{ formatMileage(report.totalMileage) }}</td>
                <td class="label">问题电芯</td>
                <td class="value">{{ detail && detail.alarm_cells ? detail.alarm_cells : '—' }}</td>
              </tr>
              <tr>
                <td class="label">风险等级</td>
                <td class="value">{{ riskLevelText }}</td>
                <td class="label">风险时间</td>
                <td class="value">—</td>
              </tr>
              <tr>
                <td class="label">有效数据截止时间</td>
                <td class="value" colspan="3">
                  {{ detail && detail.last_data_time ? detail.last_data_time : '—' }}
                  <i class="el-icon-info" style="margin-left: 4px; color: #909399; font-size: 12px;"></i>
                </td>
              </tr>
            </tbody>
          </table>
        </section>

        <!-- 二、三 两列展示 -->
        <section class="report-section two-col-section">
          <div class="two-col-col">
            <h3 class="section-title">二、电池系统健康度评价</h3>
            <div class="evaluation-row">
              <div class="gauge-wrap">
                <el-progress type="circle" :percentage="healthScore" :width="120" :stroke-width="8"
                  :color="healthScoreColor">
                  <template slot="default">
                    <span class="gauge-value">{{ healthScore }}</span>
                    <span class="gauge-label">{{ healthLevelText }}</span>
                  </template>
                </el-progress>
              </div>
              <div class="table-wrap">
                <table class="info-table two-col-table">
                  <tbody>
                    <tr>
                      <td class="label">1.电池健康状态(SOH) (车显)</td>
                      <td class="value">{{ report.soh != null ? report.soh : '—' }}</td>
                    </tr>
                    <tr>
                      <td class="label">2.单体容量一致性</td>
                      <td class="value">{{ valueToDesc(detail && detail.consistency_capacity, valueDesc.level) }}</td>
                    </tr>
                    <tr>
                      <td class="label">3.单体内阻一致性</td>
                      <td class="value">{{ valueToDesc(detail && detail.consistency_internal_resistance,
                        valueDesc.level) }}</td>
                    </tr>
                    <tr>
                      <td class="label">4.SOC一致性</td>
                      <td class="value">{{ valueToDesc(detail && detail.consistency_soc, valueDesc.level) }}</td>
                    </tr>
                    <tr>
                      <td class="label">5.电压一致性</td>
                      <td class="value">{{ valueToDesc(detail && detail.consistency_vol, valueDesc.level) }}</td>
                    </tr>
                    <tr>
                      <td class="label">6.电池容量衰退速度</td>
                      <td class="value">{{ valueToDesc(detail && detail.battery_capacity_decay_rate, valueDesc.level) }}
                      </td>
                    </tr>
                    <tr :class="{ 'row-warning': isMaxCapacityShrinkMinor }">
                      <td class="label">7.最大可用容量异常缩水</td>
                      <td class="value">{{ maxCapacityShrinkText }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div class="two-col-col">
            <h3 class="section-title">三、电池系统安全性评价</h3>
            <div class="evaluation-row">
              <div class="gauge-wrap">
                <el-progress type="circle" :percentage="safetyScore" :width="120" :stroke-width="8" color="#409EFF">
                  <template slot="default">
                    <span class="gauge-value">{{ safetyScore }}</span>
                    <span class="gauge-label">{{ safetyLevelText }}</span>
                  </template>
                </el-progress>
              </div>
              <div class="table-wrap">
                <table class="info-table two-col-table">
                  <tbody>
                    <tr>
                      <td class="label">1.电池单体短路故障</td>
                      <td class="value">{{ valueToDesc(detail && detail.abnormal_short_circuit,
                        valueDesc.safetyAbnormal) }}</td>
                    </tr>
                    <tr>
                      <td class="label">2.电池析理异常</td>
                      <td class="value">{{ valueToDesc(detail && detail.abnormal_lithium_precipitation,
                        valueDesc.safetyAbnormal)
                      }}</td>
                    </tr>
                    <tr>
                      <td class="label">3.电池老化异常</td>
                      <td class="value">{{ valueToDesc(detail && detail.abnormal_preburn, valueDesc.safetyAbnormal) }}
                      </td>
                    </tr>
                    <tr>
                      <td class="label">4.电池一致性异常</td>
                      <td class="value">{{ valueToDesc(detail && detail.abnormal_consistence, valueDesc.safetyAbnormal)
                      }}</td>
                    </tr>
                    <tr>
                      <td class="label">5.绝缘异常</td>
                      <td class="value">{{ valueToDesc(detail && detail.abnormal_insulation, valueDesc.safetyNormal) }}
                      </td>
                    </tr>
                    <tr>
                      <td class="label">6.电池温度异常</td>
                      <td class="value">{{ valueToDesc(detail && detail.abnormal_temp, valueDesc.safetyNormal) }}</td>
                    </tr>
                    <tr>
                      <td class="label">7.单体电压异常变化</td>
                      <td class="value">{{ valueToDesc(detail && detail.abnormal_voltage, valueDesc.safetyNormal) }}
                      </td>
                    </tr>
                    <tr>
                      <td class="label">8.采样异常</td>
                      <td class="value">{{ valueToDesc(detail && detail.abnormal_sampling, valueDesc.safetyNormal) }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </section>

        <!-- 八、告警详情 -->
        <section class="report-section">
          <h3 class="section-title">八、告警详情</h3>
          <div class="alarm-subsection">
            <h4 class="subsection-title">中长时间尺度报警列表</h4>
            <el-table v-if="alarmListDisplay.length" :data="alarmListDisplay" border size="small" class="alarm-table">
              <el-table-column type="index" label="报警编号" width="80" :index="i => i + 1" />
              <el-table-column prop="cell_no" label="报警电芯编号" width="110" />
              <el-table-column prop="alarm_type" label="报警类型" min-width="160" show-overflow-tooltip />
              <el-table-column prop="alarm_level" label="告警等级" width="90" />
              <el-table-column prop="alarm_time" label="报警时间" width="170" />
              <el-table-column prop="alarm_number" label="报警次数" width="90" />
            </el-table>
            <div v-else class="alarm-empty">
              <i class="el-icon-document"></i>
              <span>暂无数据</span>
            </div>
          </div>
          <div class="alarm-subsection">
            <h4 class="subsection-title">短时间尺度算法报警列表</h4>
            <el-table v-if="alarmListShortDisplay.length" :data="alarmListShortDisplay" border size="small"
              class="alarm-table">
              <el-table-column type="index" label="报警编号" width="80" :index="i => i + 1" />
              <el-table-column prop="cell_no" label="报警电芯编号" width="110" />
              <el-table-column prop="alarm_type" label="报警类型" min-width="160" show-overflow-tooltip />
              <el-table-column label="告警等级" width="90">
                <template slot-scope="">—</template>
              </el-table-column>
              <el-table-column prop="alarm_time" label="报警时间" width="170" />
              <el-table-column prop="alarm_number" label="报警次数" width="90" />
            </el-table>
            <div v-else class="alarm-empty">
              <i class="el-icon-document"></i>
              <span>暂无数据</span>
            </div>
          </div>
        </section>
      </template>
      <div v-else-if="!loading" class="no-data">暂无检测报告数据</div>
    </div>
  </el-dialog>
</template>

<script>
import { getBatteryReport } from "@/api/vehicle";

/** 实体类注释对应的值→说明映射（ReportJsonDetail 等） */
const VALUE_DESC = {
  /** 1: 优 2: 良 - 电池健康、一致性、容量衰退速度 */
  level: { 1: "优", 2: "良" },
  /** 1: 优 2: 轻微 - 最大可用容量异常缩水 */
  maxCapacityShrink: { 1: "优", 2: "轻微", 3: "严重" },
  /** 风险等级 */
  riskLevel: { 4: "无风险" },
  /** 1: 无 - 短路、析锂、预燃、一致性异常 */
  safetyAbnormal: { 1: "无" },
  /** 1: 正常 - 绝缘、温度、电压、采样异常 */
  safetyNormal: { 1: "正常" }
};

export default {
  name: "BatteryReportDialog",
  data() {
    return {
      visible: false,
      loading: false,
      vehicleId: null,
      reportDateTime: null,
      report: null,
      valueDesc: VALUE_DESC
    };
  },
  computed: {
    detail() {
      return this.report && this.report.reportJsonDetail ? this.report.reportJsonDetail : null;
    },
    /** 中长时间尺度报警列表（reportJsonDetail 下划线字段 alarm_list） */
    alarmListDisplay() {
      if (!this.detail || !Array.isArray(this.detail.alarm_list)) return [];
      return this.detail.alarm_list;
    },
    /** 短时间尺度算法报警列表（reportJsonDetail 下划线字段 alarm_list_short） */
    alarmListShortDisplay() {
      if (!this.detail || !Array.isArray(this.detail.alarm_list_short)) return [];
      return this.detail.alarm_list_short;
    },
    healthScore() {
      if (this.detail && this.detail.battery_power_score != null) {
        return this.detail.battery_power_score;
      }
      return this.report && this.report.soh != null ? this.report.soh : 0;
    },
    healthScoreColor() {
      const s = this.healthScore;
      if (s >= 90) return "#409EFF";
      if (s >= 70) return "#E6A23C";
      return "#F56C6C";
    },
    healthLevelText() {
      const s = this.healthScore;
      if (s >= 90) return "优";
      if (s >= 70) return "良";
      return "差";
    },
    safetyScore() {
      return this.detail && this.detail.batter_safety_score != null ? this.detail.batter_safety_score : 0;
    },
    safetyLevelText() {
      const s = this.safetyScore;
      if (s >= 90) return "优";
      if (s >= 70) return "良";
      return "差";
    },
    riskLevelText() {
      const v = this.detail && this.detail.risk_level;
      return this.valueToDesc(v, this.valueDesc.riskLevel);
    },
    isMaxCapacityShrinkMinor() {
      return this.detail && this.detail.max_use_capacity_shrink === 2;
    },
    maxCapacityShrinkText() {
      const v = this.detail && this.detail.max_use_capacity_shrink;
      return this.valueToDesc(v, this.valueDesc.maxCapacityShrink);
    }
  },
  methods: {
    open(vehicleId) {
      this.vehicleId = vehicleId;
      this.visible = true;
    },
    async loadData() {
      if (this.vehicleId == null) {
        this.$message.warning("缺少车辆ID");
        return;
      }
      this.loading = true;
      try {
        const res = await getBatteryReport(this.vehicleId, this.reportDateTime);
        this.report = res.data;
      } catch (e) {
        this.report = null;
        this.$message.error("获取检测报告失败");
      } finally {
        this.loading = false;
      }
    },
    clearData() {
      this.report = null;
      this.vehicleId = null;
      this.reportDateTime = null;
    },
    onReportDateTimeChange() {
      if (this.vehicleId != null) this.loadData();
    },
    formatMileage(val) {
      if (val == null) return "—";
      if (typeof val === "number") return (val / 10).toFixed(1);
      return String(val);
    },
    /** 根据实体注释映射：有说明则展示说明，否则展示原值 */
    valueToDesc(value, map, emptyStr) {
      if (emptyStr === undefined) emptyStr = "—";
      if (value == null) return emptyStr;
      if (map && map[value] !== undefined) return map[value];
      return String(value);
    },
    handleDownload() {
      this.$message.info("下载功能待实现");
    }
  }
};
</script>

<style lang="less" scoped>
.battery-report-dialog {
  .el-dialog__header {
    padding: 12px 16px;
    border-bottom: 1px solid #ebeef5;
  }

  .el-dialog__body {
    padding: 16px;
    max-height: 80vh;
    overflow-y: auto;
  }
}

.dialog-title-text {
  font-size: 16px;
  font-weight: 500;
}

.dialog-title-actions {
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  gap: 16px;

  i {
    cursor: pointer;
    font-size: 18px;
    color: #606266;

    &:hover {
      color: #409eff;
    }
  }
}

.report-toolbar {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
}

.report-body {
  min-height: 200px;
}

.report-section {
  margin-bottom: 24px;

  &:last-child {
    margin-bottom: 0;
  }
}

.section-title {
  font-size: 14px;
  font-weight: 600;
  color: #303133;
  margin: 0 0 12px 0;
  padding: 0;
}

.alarm-subsection {
  margin-bottom: 20px;

  &:last-child {
    margin-bottom: 0;
  }
}

.subsection-title {
  font-size: 13px;
  font-weight: 500;
  color: #606266;
  margin: 0 0 8px 0;
  padding: 0;
}

.alarm-table {
  font-size: 13px;
}

.alarm-empty {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 24px;
  color: #909399;
  font-size: 13px;
  background: #fafafa;
  border: 1px solid #ebeef5;
  border-radius: 4px;

  i {
    font-size: 32px;
  }
}

.info-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;

  .label {
    width: 160px;
    padding: 8px 12px;
    background: #f5f7fa;
    color: #606266;
    border: 1px solid #ebeef5;
  }

  .value {
    padding: 8px 12px;
    border: 1px solid #ebeef5;
    color: #303133;
  }

  tr.row-warning .value {
    background: #fdf6ec;
    color: #e6a23c;
  }
}

/* 二、三 两列并排 */
.two-col-section {
  display: flex;
  flex-wrap: nowrap;
  gap: 24px;
  align-items: flex-start;
}

.two-col-col {
  flex: 1;
  min-width: 0;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  padding: 12px 16px;
  background: #fafafa;
}

.two-col-col .section-title {
  margin-bottom: 12px;
}

.evaluation-row {
  display: flex;
  align-items: flex-start;
  gap: 32px;
}

.gauge-wrap {
  flex-shrink: 0;
  text-align: center;

  .gauge-value {
    display: block;
    font-size: 24px;
    font-weight: 600;
    color: #303133;
  }

  .gauge-label {
    display: block;
    font-size: 14px;
    color: #606266;
    margin-top: 4px;
  }
}

.table-wrap {
  flex: 1;
  min-width: 0;
}

.no-data {
  text-align: center;
  color: #909399;
  padding: 40px 0;
}
</style>
